module.exports = __webpack_public_path__ + "static/media/16.616b361b.png";